import { api } from '@/lib/api';
import { Sala, CreateSalaRequest, UpdateSalaRequest, SalaListResponse } from '@/types/sala';

export class SalaService {
  static async getSalas(
    page: number = 1,
    limit: number = 10,
    search?: string,
    is_active?: boolean
  ): Promise<SalaListResponse> {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (search) params.append('search', search);
      if (is_active !== undefined) params.append('is_active', is_active.toString());

      const url = `/api/salas?${params}`;
      
      
      const response = await api.get(url);
      
      
      
      return response.data.data;
    } catch (error: unknown) {
      console.error('Erro ao buscar salas:', error);
      throw new Error('Erro ao buscar salas');
    }
  }

  static async getSalaById(id: string): Promise<Sala> {
    try {
      const response = await api.get(`/api/salas/${id}`);
      return response.data.data;
    } catch (error: unknown) {
      console.error('Erro ao buscar sala:', error);
      throw new Error('Erro ao buscar sala');
    }
  }

  static async createSala(data: CreateSalaRequest): Promise<Sala> {
    try {
      const response = await api.post('/api/salas', data);
      return response.data.data;
    } catch (error: unknown) {
      console.error('Erro ao criar sala:', error);
      throw new Error('Erro ao criar sala');
    }
  }

  static async updateSala(id: string, data: UpdateSalaRequest): Promise<Sala> {
    try {
      const response = await api.put(`/api/salas/${id}`, data);
      return response.data.data;
    } catch (error: unknown) {
      console.error('Erro ao atualizar sala:', error);
      throw new Error('Erro ao atualizar sala');
    }
  }

  static async deleteSala(id: string): Promise<void> {
    try {
      await api.delete(`/api/salas/${id}`);
    } catch (error: unknown) {
      console.error('Erro ao excluir sala:', error);
      throw new Error('Erro ao excluir sala');
    }
  }

  static async getSalasAtivas(): Promise<Sala[]> {
    try {
      const response = await api.get('/api/salas/ativas');
      return response.data.data;
    } catch (error: unknown) {
      console.error('Erro ao buscar salas ativas:', error);
      throw new Error('Erro ao buscar salas ativas');
    }
  }

  static async listarSalas(): Promise<Sala[]> {
    try {
      const response = await api.get('/api/salas');
      return response.data.salas;
    } catch (error: unknown) {
      console.error('Erro ao listar salas:', error);
      throw new Error('Erro ao buscar salas');
    }
  }

  static async criarSala(dadosSala: Omit<Sala, 'id' | 'created_at' | 'updated_at'>): Promise<Sala> {
    try {
      const response = await api.post('/api/salas', dadosSala);
      return response.data.sala;
    } catch (error: unknown) {
      console.error('Erro ao criar sala:', error);
      throw new Error('Erro ao criar sala');
    }
  }

  static async obterSala(id: string): Promise<Sala> {
    try {
      const response = await api.get(`/api/salas/${id}`);
      return response.data.sala;
    } catch (error: unknown) {
      console.error('Erro ao obter sala:', error);
      throw new Error('Erro ao buscar sala');
    }
  }

  static async atualizarSala(id: string, dadosSala: Partial<Sala>): Promise<Sala> {
    try {
      const response = await api.put(`/api/salas/${id}`, dadosSala);
      return response.data.sala;
    } catch (error: unknown) {
      console.error('Erro ao atualizar sala:', error);
      throw new Error('Erro ao atualizar sala');
    }
  }

  static async deletarSala(id: string): Promise<void> {
    try {
      await api.delete(`/api/salas/${id}`);
    } catch (error: unknown) {
      console.error('Erro ao deletar sala:', error);
      throw new Error('Erro ao deletar sala');
    }
  }

  static async alterarStatusSala(id: string, ativo: boolean): Promise<Sala> {
    try {
      const response = await api.patch(`/api/salas/${id}/status`, { ativo });
      return response.data.sala;
    } catch (error: unknown) {
      console.error('Erro ao alterar status da sala:', error);
      throw new Error('Erro ao alterar status da sala');
    }
  }
} 